var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_10686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 4.4375H2.75C2.43934 4.4375 2.1875 4.68934 2.1875 5V6.6875C2.1875 6.99816 2.43934 7.25 2.75 7.25H16.25C16.5607 7.25 16.8125 6.99816 16.8125 6.6875V5C16.8125 4.68934 16.5607 4.4375 16.25 4.4375Z",
    stroke: "#3F3F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6875 7.25V14C15.6875 14.1492 15.6282 14.2923 15.5227 14.3977C15.4173 14.5032 15.2742 14.5625 15.125 14.5625H3.875C3.72582 14.5625 3.58274 14.5032 3.47725 14.3977C3.37176 14.2923 3.3125 14.1492 3.3125 14V7.25",
    stroke: "#3F3F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 10.0625H11.1875",
    stroke: "#3F3F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_10686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveBlackIcon);
export default __webpack_public_path__ + "static/media/archive-black-icon.29c743e23ba9694f2b6e684e5123583d.svg";
export { ForwardRef as ReactComponent };